import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import Component from '../Component';
/**
 * Starting with Safari on iOS 13 browsers require sites to be
 * served over https and request user permission to access DeviceOrientation events.
 * This component presents a permission dialog for the user to grant or deny access.
 * The device-orientation-permission-ui component applies only to the [`<a-scene>` element](https://aframe.io/docs/1.3.0/core/scene.html)
 *
 * @see https://aframe.io/docs/1.3.0/components/device-orientation-permission-ui.html
 */

export var DeviceOrientationPermissionUI = /*#__PURE__*/function (_Component) {
  _inheritsLoose(DeviceOrientationPermissionUI, _Component);

  function DeviceOrientationPermissionUI() {
    return _Component.apply(this, arguments) || this;
  }

  return DeviceOrientationPermissionUI;
}(Component);